import { Vue, Component, Watch } from 'vue-property-decorator'
import { store } from '../../../../store';
import { defaultParams, MixerType } from '../../../../modules/SspDataModule';
import { range } from '@/utils/range';

const memory = {
  expert: false,
  radio: 'normal',
  mixerType: 'color',
  beta: 57338.67405054002,
}

@Component
export default class extends Vue {
  expert = memory.expert
  radio = memory.radio
  mixerType = memory.mixerType
  beta = memory.beta

  mounted() {
    this.$watch(() => [this.expert, this.radio, this.mixerType, this.beta], () => {
      const { expert, radio, mixerType, beta } = this
      Object.assign(memory, { expert, radio, mixerType, beta })
    })
  }

  get gc() {
    return store.galaxyCruise
  }

  get sdssParams() {
    return this.params.sdssTrueColor
  }

  get params() {
    return store.currentFrame.modules.sspData.params
  }

  @Watch('mixerType')
  onMixerTypeChange() {
    switch (this.mixerType) {
      case 'color':
        this.params.type = MixerType.SDSS_TRUE_COLOR
        break
      case 'gri': case 'g': case 'r': case 'i':
        this.params.type = MixerType.MATRIX
        this.params.matrix.matrix = {
          gri: range(9).map((i) => 1 / 3),
          g: [0, 0, 1, 0, 0, 1, 0, 0, 1],
          r: [0, 1, 0, 0, 1, 0, 0, 1, 0],
          i: [1, 0, 0, 1, 0, 0, 1, 0, 0],
        }[this.mixerType]
        break
    }
  }

  @Watch('expert')
  onAdjustTypeChange() {
    if (!this.expert) {
      this.onRadioChange('normal')
      this.radio = 'normal'
      if (this.mixerType !== 'color') {
        this.mixerType = 'g'
      }
    }
  }

  @Watch('radio')
  onRadioChange(radio: string) {
    // @ts-ignore
    const beta = {
      dark: 1.e+4,
      normal: 57338.67405054002,
      bright: 2.e+5,
    }[radio]
    this.beta = beta
  }

  @Watch('beta')
  onBetaChange() {
    this.params.sdssTrueColor.beta = this.beta
    this.params.matrix.beta = this.beta
  }
}
